import { createSrcSet } from '../../utils/image';
import { MewsImageProps } from './MewsImageProps';

export const DEFAULT_SOURCE_SET_WIDTHS = [640, 768, 1024, 1366, 1600, 1920];
export const DEFAULT_RATIO = 16 / 9;

export const withMewsSrcSet =
    <P extends MewsImageProps>(Component: React.ComponentType<P>) =>
    ({ src, widthSet = DEFAULT_SOURCE_SET_WIDTHS, ratio = DEFAULT_RATIO, ...other }: P) => (
        <Component {...(other as P)} src={src} srcSet={createSrcSet(src, widthSet, ratio)} />
    );
